export { Global } from "./global.component";
